var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStartDoubleQuotation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 30,
    viewBox: "0 0 36 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE2\x80\x9C",
    d: "M14.1016 0V5.97656C12.2266 6.08073 10.8073 6.43229 9.84375 7.03125C8.88021 7.60417 8.20312 8.55469 7.8125 9.88281C7.42188 11.1849 7.22656 13.0599 7.22656 15.5078H14.1016V29.7656H0V16.2109C0 10.612 1.1849 6.51042 3.55469 3.90625C5.95052 1.30208 9.46615 0 14.1016 0ZM35.3906 0V5.97656C33.5156 6.08073 32.0964 6.41927 31.1328 6.99219C30.1693 7.53906 29.4661 8.48958 29.0234 9.84375C28.6068 11.1719 28.3984 13.0599 28.3984 15.5078H35.3906V29.7656H21.2109V16.2109C21.2109 10.612 22.3958 6.51042 24.7656 3.90625C27.1354 1.30208 30.6771 0 35.3906 0Z",
    fill: "#252429",
    fillOpacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStartDoubleQuotation);
export default __webpack_public_path__ + "static/media/start-double-quotation.fe5610c2840de373c4077f27c0d97a42.svg";
export { ForwardRef as ReactComponent };